import { WebshopProductDetail } from '@cldsystems/ws-api-client';

type BreadcrumbsType = {
  label: string;
  url: string;
}[];

export const getBreadcrumbs = (product: WebshopProductDetail) => {
  const result: BreadcrumbsType = [];
  product.superCategories.forEach(item => {
    result.push({
      label: item.name,
      url: `/products/${item.meta.url!}`,
    });
  });

  return result;
};
